import { render, staticRenderFns } from "./r-item-select.vue?vue&type=template&id=fa180d0c"
import script from "./r-item-select.vue?vue&type=script&lang=js"
export * from "./r-item-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa180d0c')) {
      api.createRecord('fa180d0c', component.options)
    } else {
      api.reload('fa180d0c', component.options)
    }
    module.hot.accept("./r-item-select.vue?vue&type=template&id=fa180d0c", function () {
      api.rerender('fa180d0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/r-item-select.vue"
export default component.exports